module.exports = __webpack_public_path__ + "media/promo/velle/images/products/prod_3-9bea0bef24d356249adf79ab32573f8a.png";